// ===========================
// summary.head.js (new file)
// ===========================
import Func from "../../utils/Func";

export default function SummaryHead({ expiredDate }) {
  const nextExpiredDate = expiredDate ? Func.AddDaysISO(expiredDate, 1) : "";

  return (
    <tr>
      <th></th>
      <th>Person</th>
      <th>
        Annual Leave Days
        <div className="red-text small-text">
          From
          <br />
          01 Jan {Func.GetCurrentYear()}
        </div>
      </th>
      <th>
        Last Year Balance{" "}
        {expiredDate && (
          <div className="red-text small-text">
            Expires on
            <br />
            {Func.ConvertDateFormat(expiredDate)}
          </div>
        )}
      </th>
      <th>
        Current Year Balance
        <div className="red-text small-text">
          From
          <br />
          01 Jan {Func.GetCurrentYear()}
        </div>
      </th>
      <th>Leave Days Taken</th>
      <th>
        Leave Days Expired{" "}
        {nextExpiredDate && (
          <div className="red-text small-text">
            From
            <br />
            {Func.ConvertDateFormat(nextExpiredDate)}
          </div>
        )}
      </th>
      <th>Leave Days Balance</th>
      <th>Compensatory Leave Balance</th>
      <th>Compensatory Leave Used</th>
      <th>Sick Leave Used</th>
    </tr>
  );
}
